import React from 'react';
import PropTypes from 'prop-types';

import { IconHamburger, IconLeftArrow } from 'svgIcons/MotionPortalIcons';
import IconHierarchyView from 'svgIcons/MotionPortalIcons/IconHierarchyView';
import { translate } from 'helpers/translateHelper';
import colors from 'theme/_colors.scss';
import { conditionIndicesViewOptions } from '../../../PowertrainConditionMonitoring/ConditionIndicesOverviewV2/constants';

const ConditionOverviewToggle = ({ expanded, conditionIndicesView, setConditionIndicesView, isRight, showCollapseButton, onToggle, expandedIcon, collapsedIcon }) => {
    return (
        <div className={`hierarchy-column-sidebar-toggle ${expanded ? 'expanded' : 'collapsed'}`}>
            {expanded &&
                <div className={'condition-overview-toggle'}>
                    <button
                        className={`toggle-icons ${conditionIndicesView === conditionIndicesViewOptions.LIST ? 'selected' : ''}`}
                        onClick={() => setConditionIndicesView(conditionIndicesViewOptions.LIST)}
                        type='button'>
                        <IconHamburger width={24} height={24} />
                    </button>
                    <button
                        className={`toggle-icons ${conditionIndicesView === conditionIndicesViewOptions.HIERARCHY ? 'selected' : ''}`}
                        onClick={() => setConditionIndicesView(conditionIndicesViewOptions.HIERARCHY)}
                        type='button'>
                        <IconHierarchyView width={24} height={24} />
                    </button>
                    <div className='condition-overview-toggle-info'>
                        <IconLeftArrow color={colors.doveGray} width={12} height={12} />
                        <span className='condition-overview-toggle-text'>{translate('ABB.Powertrain.Frontend.hierarchyViewInfoLabel')}</span>
                    </div>
                </div>
            }
            {showCollapseButton &&
                <button
                    type='button'
                    aria-label={expanded ? 'Collapse sidebar' : 'Expand sidebar'}
                    onClick={onToggle}
                    className={`column-sidebar-toggle-button ${expanded ? 'expanded' : 'collapsed'} ${isRight ? 'right' : 'left'}`}
                >
                    {expanded ? expandedIcon : collapsedIcon}
                </button>
            }
        </div>
    );
};

ConditionOverviewToggle.propTypes = {
    expanded: PropTypes.bool,
    conditionIndicesView: PropTypes.string,
    setConditionIndicesView: PropTypes.func,
    isRight: PropTypes.bool,
    showCollapseButton: PropTypes.oneOfType([PropTypes.bool, PropTypes.node]),
    onToggle: PropTypes.func,
    expandedIcon: PropTypes.node,
    collapsedIcon: PropTypes.node,
};

export default ConditionOverviewToggle;
